export class Menu {
    constructor() {
        this.body = document.body;
        this.siteHeader = document.getElementById("site-header");
        this.menuButton = document.getElementById("main-menu-btn");
        this.close = document.getElementById("nav-closer");
        this.tabtitles = document.querySelector(".b-tabs__titles");
        this.phoneNumberDropdownOpener = this.body.querySelector(".phone-numbers");

        this.isMenuExpanded = false;

        this.throttledHandleScroll = this.throttle(this.handleScroll.bind(this), 100);

        this.addEventListeners();
        this.initSliderControls();
        this.setNavCloserHeight();

        //scrolling variables
        this.lastScrollPosition = 0;
        // this.scrollThreshold = 200; // Your existing scroll threshold
        this.headerHideTimeout = null;
    }

    addEventListeners() {
        if (window.innerWidth < 1024) {
            this.menuButton.addEventListener('click', this.handleMenuClick.bind(this));
            this.movePhoneElements();
        } else {
            this.menuButton.addEventListener('click', this.closeMenu.bind(this));
            this.close.addEventListener('click', this.closeMenu.bind(this));
            this.setActiveMenuItem();
        }

        // Add event listener for sub-menu click
        const subMenuItems = document.querySelectorAll('.main-menu__el.-has-children');
        subMenuItems.forEach(item => {
            item.addEventListener('click', (event) => this.handleSubMenuClick(event, item));
        });

        // Prevent triggering the submenu when clicking on normal links with class main-menu__el
        const normalMenuItems = document.querySelectorAll('.main-menu__el:not(.-has-children) > a');
        normalMenuItems.forEach(item => {
            item.addEventListener('click', (event) => {
                event.stopPropagation(); // Prevent any submenu toggle or related event
            });
        });

        // Prevent any link with href="#" from scrolling to top
        const allMenuLinks = document.querySelectorAll('.main-menu__el > a');
        allMenuLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                if (link.getAttribute("href") === "#") {
                    event.preventDefault();
                }
            });
        });

        // Add scroll event listener for desktops with throttling
        if (window.innerWidth > 1024) {
            window.addEventListener('scroll', this.throttledHandleScroll);
        }
        this.initSliderControls();

    }

    initSliderControls() {
        // Use a mutation observer to ensure the controls exist
        const observer = new MutationObserver((mutations) => {
            const sliderControls = document.querySelectorAll('.menu-slider .splide__arrows .splide__arrow');
            if (sliderControls.length > 0) {
                sliderControls.forEach(control => {
                    // Remove any existing listeners first to prevent duplicates
                    control.removeEventListener('click', this.preventMenuClose);
                    control.addEventListener('click', this.preventMenuClose);
                });
                // Disconnect observer once controls are found
                observer.disconnect();
            }
        });

        // Start observing the document with the configured parameters
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

// Bind this method to the class to preserve 'this' context
    preventMenuClose = (event) => {
        event.stopPropagation();
    }

    movePhoneElements() {
        console.log("movePhoneElements")
        const phoneDropdown = this.body.querySelector(".phone-numbers__dropdown");
        const menuMainNav = this.body.querySelector(".main-menu__list");

        console.log(menuMainNav)

        if (phoneDropdown && menuMainNav) {
            menuMainNav.appendChild(phoneDropdown);
        }
    }

    handleMenuClick() {
        if (this.isMenuExpanded) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.siteHeader.classList.add("menu-opened");
        this.isMenuExpanded = true;
    }

    closeMenu() {
        this.siteHeader.classList.remove("menu-opened");

        if (window.innerWidth > 1024) {
            const openSubMenus = document.querySelectorAll(`.main-menu__el.-level-0.main-menu__el--sub-list-opened`);
            openSubMenus.forEach(openSubMenu => {
                if (openSubMenu) {
                    openSubMenu.classList.remove("main-menu__el--sub-list-opened");
                }
            });
            this.body.classList.remove("main-menu-opened");
        }
        this.isMenuExpanded = false;
    }

    handleSubMenuClick(event, node) {
        // Check if the click is directly on a menu item or its children
        const isDirectMenuItemClick = event.target.closest('.main-menu__el.-has-children');

        if (isDirectMenuItemClick) {
            event.stopPropagation();
            this.isMenuExpanded = true;

            const clickedSubMenuItem = node || event.currentTarget;
            const level = Array.from(clickedSubMenuItem.classList).find(cls => cls.startsWith('-level-'));

            const openSubMenus = document.querySelectorAll(`.main-menu__el.${level}.main-menu__el--sub-list-opened`);
            openSubMenus.forEach(openSubMenu => {
                if (openSubMenu !== clickedSubMenuItem) {
                    openSubMenu.classList.remove("main-menu__el--sub-list-opened");
                }
            });

            clickedSubMenuItem.classList.toggle("main-menu__el--sub-list-opened");
            this.setNavCloserHeight();
        }


        if (window.innerWidth > 1024) {
            // this.setSubmenuHeight();
            // Check if a top-level (level-0) menu item has the 'main-menu__el--sub-list-opened' class
            const level0Open = document.querySelector('.main-menu__el.-level-0.main-menu__el--sub-list-opened');
            if (level0Open) {
                // Add 'menu-opened' class when a top-level submenu is opened
                this.siteHeader.classList.add("menu-opened");
                this.body.classList.add("main-menu-opened");
            } else {
                // Remove 'menu-opened' class if no top-level submenu is open
                this.siteHeader.classList.remove("menu-opened");
                this.body.classList.remove("main-menu-opened");
            }
        }
    }

    setNavCloserHeight() {
        if (this.close && this.siteHeader) {
            const subLists = this.siteHeader.querySelectorAll('.main-menu__el.-level-0.-has-children > .main-menu__sub-list');
            let totalSubListHeight = 0;

            subLists.forEach(subList => {
                totalSubListHeight += subList.offsetHeight;
            });

            // const calculatedHeight = window.innerHeight - totalSubListHeight - this.siteHeader.offsetHeight;
            const calculatedHeight = window.innerHeight - totalSubListHeight;
            this.close.style.height = `${calculatedHeight}px`;
        }
    }

    handleScroll() {
        const currentScrollPosition = window.scrollY;
        const scrollThreshold = 100; // Hide header after 100px scroll down

        // Determine scroll direction
        const isScrollingDown = currentScrollPosition > this.lastScrollPosition;
        const isScrollingUp = currentScrollPosition < this.lastScrollPosition;

        // Close menu if needed
        if (this.isMenuExpanded && currentScrollPosition > scrollThreshold) {
            this.closeMenu();
        }

        // Header hide/show logic
        if (currentScrollPosition > scrollThreshold) {
            if (isScrollingDown) {
                // Hide header when scrolling down past 100px
                if (!this.headerHideTimeout) {
                    this.headerHideTimeout = setTimeout(() => {
                        this.siteHeader.classList.add('header-hidden');
                        if (this.tabtitles) {
                            this.tabtitles.classList.add('header-hidden');
                        }
                    }, 300); // Small delay for smoother transition
                }
            } else if (isScrollingUp) {
                // Show header immediately when scrolling up
                if (this.headerHideTimeout) {
                    clearTimeout(this.headerHideTimeout);
                    this.headerHideTimeout = null;
                }
                this.siteHeader.classList.remove('header-hidden');
                if (this.tabtitles) {
                    this.tabtitles.classList.remove('header-hidden');
                }
            }
        } else {
            // Always show header when near the top of the page (within 100px)
            this.siteHeader.classList.remove('header-hidden');
            if (this.tabtitles) {
                this.tabtitles.classList.remove('header-hidden');
            }
        }

        // Update last scroll position
        this.lastScrollPosition = currentScrollPosition;
    }

    throttle(callback, delay) {
        let lastTime = 0;

        return function (...args) {
            const now = Date.now();

            if (now - lastTime >= delay) {
                lastTime = now;
                callback.apply(this, args);
            }
        };
    }

    setActiveMenuItem() {
        // Find all level-0 menu items
        const level0Items = document.querySelectorAll('.main-menu__el.-level-0');

        level0Items.forEach(level0Item => {
            // Check if any submenu item within this level-0 item has the current class
            const hasCurrentSubmenu = level0Item.querySelector('.main-menu__el--current');

            // Toggle the -current class on the level-0 item
            level0Item.classList.toggle('-current', !!hasCurrentSubmenu);
        });
    }
}
